import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function AzureResourceGroupField({
  value,
  error,
  setValue,
  setError,
  setChanged,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    if (newValue === '') {
      setError('Resource Group cannot be blank.');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='Resource Group'
          id='resource-group'
          aria-describedby='resource-group-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={error}
          value={value}
        />
        {error ? (
          <FormHelperText id='resource-group-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='resource-group-helper-text'>
            Enter the Azure Resource Group
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

